export default __webpack_public_path__ + "up-chevron-button.png";